"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FastAuditsQuota_1 = __importDefault(require("./quotas/FastAuditsQuota"));
const FastAuditsMeteredQuota_1 = __importDefault(require("./quotas/FastAuditsMeteredQuota"));
const PageTypesAuditsQuota_1 = __importDefault(require("./quotas/PageTypesAuditsQuota"));
const PageTypesAuditsMeteredQuota_1 = __importDefault(require("./quotas/PageTypesAuditsMeteredQuota"));
const ProjectsQuota_1 = __importDefault(require("./quotas/ProjectsQuota"));
const SavedReportsQuota_1 = __importDefault(require("./quotas/SavedReportsQuota"));
const ChecklistsQuota_1 = __importDefault(require("./quotas/ChecklistsQuota"));
const NoQuota_1 = __importDefault(require("./quotas/NoQuota"));
const AuditBlueprintsQuota_1 = __importDefault(require("./quotas/AuditBlueprintsQuota"));
const NewFastAuditsQuota_1 = __importDefault(require("./quotas/NewFastAuditsQuota"));
const NewPageTypesAuditsQuota_1 = __importDefault(require("./quotas/NewPageTypesAuditsQuota"));
const NewFastAuditsMeteredQuota_1 = __importDefault(require("./quotas/NewFastAuditsMeteredQuota"));
const NewPageTypesAuditsMeteredQuota_1 = __importDefault(require("./quotas/NewPageTypesAuditsMeteredQuota"));
class QuotasFactory {
    constructor(statsCollection) {
        this.quotas = {
            'fast_audits': {
                make_new: () => new NewFastAuditsQuota_1.default(this.statsCollection, this),
                run: () => new FastAuditsQuota_1.default(this.statsCollection)
            },
            'fast_audits_metered': {
                make_new: () => new NewFastAuditsMeteredQuota_1.default(this.statsCollection, this),
                run: () => new FastAuditsMeteredQuota_1.default(this.statsCollection),
            },
            'page_types_audits': {
                make_new: () => new NewPageTypesAuditsQuota_1.default(this.statsCollection, this),
                run: () => new PageTypesAuditsQuota_1.default(this.statsCollection)
            },
            'page_types_audits_metered': {
                make_new: () => new NewPageTypesAuditsMeteredQuota_1.default(this.statsCollection, this),
                run: () => new PageTypesAuditsMeteredQuota_1.default(this.statsCollection)
            },
            'projects': { make_new: () => new ProjectsQuota_1.default(this.statsCollection) },
            'reports': { save: () => new SavedReportsQuota_1.default(this.statsCollection) },
            'checklists': { make_new: () => new ChecklistsQuota_1.default(this.statsCollection) },
            'audit_blueprints': { make_new: () => new AuditBlueprintsQuota_1.default(this.statsCollection) },
        };
        this.statsCollection = statsCollection;
    }
    getQuota(component, action) {
        if (this.quotas[component] && this.quotas[component][action]) {
            return this.quotas[component][action];
        }
        return () => new NoQuota_1.default();
    }
}
exports.default = QuotasFactory;
